export default {
  UNPAID: 'unpaid',
  PARTIALLY_PAID: 'partially_paid',
  WAITING_PROTEST: 'waiting_protest',
  IN_PROTEST: 'in_protest',
};
